// Réalisations clients — cartes réellement conçues et produites par Noveocard.
export const REALISATIONS = [
  {
    id: "nexa-recto",
    img: "/assets/realisations/nexa-recto.webp",
    alt: "Carte digitale NEXA recto : fond noir premium, logo doré, slogan « Un simple geste ouvre un monde »",
    client: "NEXA",
    sector: "Identité de marque premium",
    detail: "Recto — fond noir profond, dorure, logo sur mesure",
  },
  {
    id: "nexa-verso",
    img: "/assets/realisations/nexa-verso.webp",
    alt: "Carte digitale NEXA verso : « Approchez votre téléphone » avec accès contact, site web, réseaux, avis et plan",
    client: "NEXA",
    sector: "Identité de marque premium",
    detail: "Verso — six accès directs et repère NFC doré",
  },
  {
    id: "otentica-duo",
    img: "/assets/realisations/otentica-duo.webp",
    alt: "Cartes digitales O'tentica pizzeria : recto rouge avec logo et verso blanc « Touchez votre téléphone »",
    client: "O'tentica — Pizzeria & Cucina Italiana",
    sector: "Restaurant",
    detail: "Recto / verso aux couleurs de la maison, fonds illustrés",
  },
  {
    id: "otentica-collection",
    img: "/assets/realisations/otentica-collection.webp",
    alt: "Collection de quatre cartes digitales O'tentica : avis Google, Instagram, TikTok et appel direct",
    client: "O'tentica — Pizzeria & Cucina Italiana",
    sector: "Restaurant",
    detail: "Collection de 4 cartes : avis Google, Instagram, TikTok, appel direct",
  },
];

// Designs de démonstration — présentés comme des exemples, pas de vrais clients.
// Palette volontairement très variée : les cartes ne sont limitées à aucune couleur.
export const GALLERY_DESIGNS = [
  { id: "noir-or", sector: "Identité premium", name: "Maison Aubert", style: "Noir & or", base: "#0A0A0A", accent: "#C9A96E" },
  { id: "blanc-bleu", sector: "Café de quartier", name: "Café Lumen", style: "Blanc & bleu", base: "#F7FAFF", accent: "#1677FF" },
  { id: "bordeaux", sector: "Restaurant", name: "Osteria Notte", style: "Bordeaux & doré", base: "#6E0E0E", accent: "#F2C94C", pattern: "gastronomie" },
  { id: "foret", sector: "Institut de beauté", name: "Éclosion", style: "Vert forêt & or", base: "#0B2B1A", accent: "#C9A96E", pattern: "botanique" },
  { id: "rose", sector: "Boutique", name: "Atelier Nova", style: "Rose poudré", base: "#F2D5DE", accent: "#A63A5B" },
  { id: "nuit", sector: "Hôtel", name: "Hôtel Riviera", style: "Bleu nuit", base: "#071A2D", accent: "#4C9AFF", pattern: "vagues" },
  { id: "corail", sector: "Coach sportif", name: "Studio Pulse", style: "Corail vif", base: "#E8503A", accent: "#FFE9D6" },
  { id: "anthracite", sector: "Garage automobile", name: "Garage Précision", style: "Anthracite", base: "#23272E", accent: "#9FB8D8" },
  { id: "creme", sector: "Agent immobilier", name: "Horizon Immobilier", style: "Crème & cacao", base: "#F5EDE0", accent: "#6B4F2E" },
];
